import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'expert'

const ExpertModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default ExpertModule



// WEBPACK FOOTER //
// ./src/store/module/expert/index.js